import { encriptarDatos } from "./encript";

const EcommerceServices = (instance) => {
  const login = (val) => instance.post(`/auth/login`, val);
  const logOut = () => instance.post(`/auth/logout`);
  const refreshToken = () => instance.post(`/auth/refresh`);
  const getLines = () => instance.get("/api/category");
  //Endpoint to get clients of user according to company
  const getClientsByCompanyAndUser = () =>
    instance.get("/api/clients/byCompanyAndUser");
  //Endpoint to get providers of user
  const getUserProviders = () => instance.get("/api/providers/all");
  //Endpoint to get sucursales of a client
  const getSucursalByClient = async (publicKey, client) => {
    const data = await encriptarDatos(publicKey, `client=${client}`);
    return instance.get(`api/sucursal/byClient/?data=${data}`);
  };
  // Endpoint to get products by line
  const getProductsByLine = async (publicKey, line) => {
    const data = await encriptarDatos(publicKey, `category=${line}`);
    return instance.get(`/api/products/all?data=${data}`);
  };
  // Endpoint to get status for orders
  const getOrderStatus = () => instance.get("/api/webStatus");
  // Endpoint to get historic orders
  const getHistoricOrders = async (publicKey, filter) => {
    const data = await encriptarDatos(publicKey, filter);
    return instance.get(`/api/orders?data=${data}`);
  };
  // Endpoint to get detail of a historic order
  const getDetailHistoricOrder = async (publicKey, id) => {
    const data = await encriptarDatos(publicKey, `id=${id}`);
    return instance.get(`/api/order?data=${data}`);
  };
  const getCurrentOrder = async (publicKey, clientId, sucursalId) => {
    const data = await encriptarDatos(
      publicKey,
      `sucursalId=${sucursalId}&clientId=${clientId}`
    );
    return instance.get(`/api/order/current?data=${data}`);
  };
  const addToCart = async (
    publicKey,
    clientId,
    sucursalId,
    products,
    { observacion = null, transporte = null, updateProduct = false } = {}
  ) => {
    const url = `/order${updateProduct ? "?updateProduct=true" : ""}`;
    return instance.post(url, {
      clientId: clientId, //clCodigo
      pwObservation: observacion,
      pwTransport: transporte,
      sucursalId: sucursalId, //clBranchOffice
      products: products,
    });
  };
  const removeFromCart = async (publicKey, orderProductId) => {
    const data = await encriptarDatos(publicKey, `id=${orderProductId}`);
    return instance.delete(`/api/order/removeProduct?data=${data}`);
  };
  const cleanCart = async (publicKey, id) => {
    const data = await encriptarDatos(publicKey, `id=${id}`);
    return instance.delete(`/api/order?data=${data}`);
  };
  const sendCart = async ({
    orderId,
    clientId,
    transport,
    observation,
    userId,
  }) => {
    return instance.put(`/order/send?orderId=${orderId}&clientId=${clientId}`, {
      transport,
      observation,
      userId,
    });
  };
  const searchProducts = async (publicKey, filter) => {
    const data = await encriptarDatos(publicKey, `filter=${filter}`);
    return instance.get(`/api/products/filtered?data=${data}`);
  };
  const getDownloads = async (publicKey, filters) => {
    const data = await encriptarDatos(publicKey, filters);
    return instance.get(`/api/porFile/all?data=${data}`);
  };
  const getDownloadsAdmin = async (publicKey, filters) => {
    const data = await encriptarDatos(publicKey, filters);
    return instance.get(`/api/porFile/all/admin?data=${data}`);
  };
  const getDownloadsStatics = async (publicKey, filters) => {
    const data = await encriptarDatos(publicKey, filters);
    return instance.get(`/api/porFile/statics?data=${data}`);
  };
  const getStatistics = async (publicKey, filters) => {
    const data = await encriptarDatos(publicKey, filters);
    return instance.get(`/api/porStatistic?data=${data}`);
  };
  const getFileTypes = () => instance.get(`/api/porFileType/all`);
  const createFileTypes = async (publicKey, body) => {
    const dataEncrypted = await encriptarDatos(publicKey, body);
    return instance.post(`/api/porFileType`, { data: [dataEncrypted] });
  };
  const updateFileTypes = async (publicKey, body) => {
    const dataEncrypted = await encriptarDatos(publicKey, body);
    return instance.put(`/api/porFileType`, { data: [dataEncrypted] });
  };
  const getFileTypesById = async (publicKey, id) => {
    const data = await encriptarDatos(publicKey, `id=${id}`);
    return instance.get(`/api/porFileType?data=${data}`);
  };
  const deleteFileTypes = async (publicKey, id) => {
    const data = await encriptarDatos(publicKey, `id=${id}`);
    return instance.delete(`/api/porFileType?data=${data}`);
  };
  const getHistoricCtaCorriente = async (publicKey, filter) => {
    const data = await encriptarDatos(publicKey, filter);
    return instance.get(`/api/historicalCtaCte?data=${data}`);
  };
  const getPendingCtaCorriente = async (publicKey, filter) => {
    const data = await encriptarDatos(publicKey, filter);
    return instance.get(`/api/pendingCtaCte?data=${data}`);
  };
  const getPendingCtaCorrienteSeller = async (publicKey, filter) => {
    const data = await encriptarDatos(publicKey, filter);
    return instance.get(`/api/pendingCtaCteSeller?data=${data}`);
  };
  const getConcepts = async (publicKey, filter) => {
    const data = await encriptarDatos(publicKey, filter);
    return instance.get(`/api/pendingCtaCte/concepts?data=${data}`);
  };
  const getSellerConcepts = async (publicKey, filter) => {
    const data = await encriptarDatos(publicKey, filter);
    return instance.get(`/api/pendingCtaCteSeller/concepts?data=${data}`);
  };
  const getClientsFiles = async (publicKey, client, filter) => {
    const data = await encriptarDatos(publicKey, `client=${client}${filter}`);
    return instance.get(`/api/porFile/clientFiles?data=${data}`);
  };
  const download = async (publicKey, id) => {
    const data = await encriptarDatos(publicKey, `id=${id}`);
    return instance.get(`/api/porFile/donwload?data=${data}`);
  };
  const getSaleDetailsByPeriods = async (publicKey, filter) => {
    const data = await encriptarDatos(publicKey, filter);
    return instance.get(`/api/saleDetail?data=${data}`);
  };
  const getSaleDetailsByPeriodsDetail = async (publicKey, filter) => {
    const data = await encriptarDatos(publicKey, filter);
    return instance.get(`/api/saleDetail/details?data=${data}`);
  };
  const getSalesalesByClient = async (publicKey, filter) => {
    const data = await encriptarDatos(publicKey, filter);
    return instance.get(`/api/salesByClient?data=${data}`);
  };
  const getSalesalesByClientDetail = async (publicKey, filter) => {
    const data = await encriptarDatos(publicKey, filter);
    return instance.get(`/api/salesByClient/details?data=${data}`);
  };
  const healtCheck = () => instance.get(`/public/health`);
  const getMenu = () => instance.get(`/api/porMenu`);
  const getPopUps = async (publicKey, filter) => {
    const data = await encriptarDatos(publicKey, filter);
    return instance.get(`/api/porPopup/all?data=${data}`);
  };
  const getGroups = async (publicKey, filter = "") => {
    const data = await encriptarDatos(publicKey, filter);
    return instance.get(`/api/porGroup/all?data=${data}`);
  };
  const createPopUp = (body: popUp) => {
    return instance.post(`/porPopup`, body);
  };
  const updatePopUp = (body: updatePopUp) => {
    return instance.put(`/porPopup`, body);
  };
  const deletePopUp = async (publicKey, id) => {
    const data = await encriptarDatos(publicKey, `id=${id}`);
    return instance.delete(`/api/porPopup/?data=${data}`);
  };
  const disablePopUp = async (publicKey, id) => {
    const data = await encriptarDatos(publicKey, `id=${id}`);
    const dataBody = await encriptarDatos(publicKey, { id: id });
    return instance.put(`/api/porPopup/changeStatus?data=${data}`, {
      data: [dataBody],
    });
  };
  const getPopUp = async (publicKey, id) => {
    const data = await encriptarDatos(publicKey, `id=${id}`);
    return instance.get(`/api/porPopup/?data=${data}`);
  };
  const getPopUpEnabled = () => instance.get(`/api/porPopup/enable`);
  const getSettings = () => instance.get(`/api/config`);
  const updateSettings = async (settings) => {
    return instance.put(`/config`, settings);
  };
  const getMaintenance = () => instance.get(`/public/maintenance`);
  const getDownloadById = async (publicKey, id) => {
    const data = await encriptarDatos(publicKey, `id=${id}`);
    return instance.get(`/api/porFile?data=${data}`);
  };
  const deletePorFile = async (publicKey, id) => {
    const data = await encriptarDatos(publicKey, `id=${id}`);
    return instance.delete(`/api/porFile?data=${data}`);
  };
  const getUsers = async (publicKey, filter) => {
    const data = await encriptarDatos(publicKey, filter);
    return instance.get(`/api/porUser/all?data=${data}`);
  };
  const getUser = async (publicKey, id: string) => {
    const data = await encriptarDatos(
      publicKey,
      `id=${id}&groupRelation=true&companyRelation=true`
    );
    return instance.get(`/api/porUser?data=${data}`);
  };
  const changePassword = async (publicKey, { email, password }) => {
    const data = await encriptarDatos(publicKey, {
      email,
      password,
    });
    return instance.post(`/api/porUser/changePassword`, { data: [data] });
  };
  const createUser = async (publicKey, user) => {
    for (let i = 0; i < user.length; i++) {
      user[i] = await encriptarDatos(publicKey, user[i]);
    }
    return instance.post(`/api/porUser`, { data: user });
  };
  const clientsByUser = async (publicKey, { userId }) => {
    const data = await encriptarDatos(publicKey, `userId=${userId}`);
    return instance.get(`/api/porUser/clients?data=${data}`);
  };
  const addClient = async (publicKey, { userId, client }) => {
    const data = await encriptarDatos(
      publicKey,
      `userId=${userId}&client=${client}`
    );
    const dataBody = await encriptarDatos(publicKey, {
      userId: userId,
      client: client,
    });
    return instance.post(`/api/porUser/addClient?data=${data}`, {
      data: [dataBody],
    });
  };
  const removeClient = async (publicKey, { userId, client }) => {
    const data = await encriptarDatos(
      publicKey,
      `userId=${userId}&client=${client}`
    );
    const dataBody = await encriptarDatos(publicKey, {
      userId: userId,
      client: client,
    });
    return instance.delete(`/api/porUser/removeClient?data=${data}`, {
      data: [dataBody],
    });
  };
  const removeAllClients = async (publicKey, { userId }) => {
    const data = await encriptarDatos(publicKey, `userId=${userId}`);
    const dataBody = await encriptarDatos(publicKey, {
      userId: userId,
    });
    return instance.delete(`/api/porUser/removeAllClients?data=${data}`, {
      data: [dataBody],
    });
  };
  const updateUser = async (publicKey, user) => {
    const encryptedFragments = await Promise.all(
      user.map((fragment) => encriptarDatos(publicKey, fragment))
    );
    return instance.put(`/api/porUser`, { data: encryptedFragments });
  };
  const deleteUser = async (publicKey, id: number) => {
    const data = await encriptarDatos(publicKey, `id=${id}`);
    return instance.delete(`/api/porUser?data=${data}`);
  };
  const clientsOptions = () => instance.get(`/api/clients/options`);
  const getAllMenuOptions = () => instance.get(`/api/porMenu/allItems`);
  const permissionsByGroup = async (publicKey, groupId) => {
    const data = await encriptarDatos(publicKey, `groupId=${groupId}`);
    return instance.get(`/api/porGroup/permissions?data=${data}`);
  };
  const getPermissionOptions = () => instance.get(`/api/porPermisos`);
  const addPermission = async (
    publicKey,
    { groupId, itemId, permissionId }
  ) => {
    const data = await encriptarDatos(publicKey, {
      groupId,
      itemId,
      permissionId,
    });
    return instance.post(`/api/porGroup/permissions`, { data: [data] });
  };
  const removePermission = async (
    publicKey,
    { groupId, itemId, permissionId }
  ) => {
    const data = await encriptarDatos(publicKey, {
      groupId,
      itemId,
      permissionId,
    });
    return instance.put(`/api/porGroup/permissions`, { data: [data] });
  };
  const updateGroup = async (publicKey, data) => {
    for (let i = 0; i < data.length; i++) {
      data[i] = await encriptarDatos(publicKey, data[i]);
    }
    return instance.put(`/api/porGroup`, { data: data });
  };
  const createGroup = async (publicKey, data) => {
    const dataEncrypted = await encriptarDatos(publicKey, data);
    return instance.post(`/api/porGroup`, { data: [dataEncrypted] });
  };
  const getGroupById = async (publicKey, id) => {
    const data = await encriptarDatos(publicKey, `id=${id}`);
    return instance.get(`/api/porGroup?data=${data}`);
  };
  const deleteGroupById = async (publicKey, id) => {
    const data = await encriptarDatos(publicKey, `id=${id}`);
    return instance.delete(`/api/porGroup?data=${data}`);
  };
  const getUsersByGroup = async (publicKey, groupId) => {
    const data = await encriptarDatos(publicKey, `groupId=${groupId}`);
    return instance.get(`/api/porUser/byGroup?data=${data}`);
  };
  const downloadFileHistoricCtaCorriente = async (publicKey, file) => {
    const data = await encriptarDatos(publicKey, `name=${file}`);
    return instance.get(`/api/historicalCtaCte/download?data=${data}`);
  };
  const passwordRecovery = (val) => instance.post(`/auth/forgotPassword`, val);
  const getZone = () => instance.get(`/api/saleDetail/zone`);
  const createFiles = async (body) => {
    return instance.post(`/porFile`, body);
  };
  const uploadFiles = (id, body) =>
    instance.post(`/upload/porFile/upload/?id=${id}`, body);
  const updateFiles = async (body) => {
    return instance.put(`/porFile`, body);
  };
  const getOrders = async (publicKey, id) => {
    const data = await encriptarDatos(publicKey, `low=${id}`);
    return instance.get(`/api/providers/ordersSAP?data=${data}`);
  };
  const getComprobantesPagados = async (publicKey, filters) => {
    const data = await encriptarDatos(publicKey, filters);
    return instance.get(`/api/providers/paidVouchers?data=${data}`);
  };
  const getPendingDocuments = async (publicKey, filters) => {
    const data = await encriptarDatos(
      publicKey,
      `vendor=${filters.vendor}&keydate=${filters.keydate}`
    );
    return instance.get(`/api/providers/pendingVouchers/?data=${data}`);
  };
  const sendVoucherMail = (body) =>
    instance.post(`/upload/providers/sendVoucher`, body);
  const getMailList = () => instance.get(`/api/config/mailList`);

  const getAllGroupCustomers = () => instance.get(`/api/group-customers-all`);
  const getAllGroupCustomersByCompany = async (publicKey, userId) => {
    let where = `&userId=${userId}`;
    const data = await encriptarDatos(publicKey, where);
    return instance.get(`/api/group-customers-bycompany?data=${data}`);
  };

  const getFilteredData = async (publicKey, filters) => {
    let where = `&filters=${filters}`;
    const data = await encriptarDatos(publicKey, where);
    return instance.get(`/api/group-customers?data=${data}`);
  };

  const createGroupCustomers = async (body) => {
    return instance.post(`/usersCustomers/create-group-customers`, body);
  };

  const addGroupClient = async (publicKey, body) => {
    const dataEncrypted = await encriptarDatos(publicKey, body);
    return instance.post(`/api/assign-group-customers`, {
      data: [dataEncrypted],
    });
  };

  const getGroupsByUserId = async (publicKey, body) => {
    let userId = `&userId=${body}`;
    const data = await encriptarDatos(publicKey, userId);
    return instance.get(`/api/get-group-by-customers?data=${data}`);
  };

  const getUsersByUsersCustomers = async (publicKey, usersCustomersId) => {
    const data = await encriptarDatos(
      publicKey,
      `usersCustomersId=${usersCustomersId}`
    );
    return instance.get(`/api/group-customers-bygroup?data=${data}`);
  };

  const getAllGroupCustomersByUser = async (publicKey, { userId }) => {
    const data = await encriptarDatos(publicKey, `userId=${userId}`);
    return instance.get(`/api/porUser/clients?data=${data}`);
  };

  const removeGroupClient = async (publicKey, body) => {
    const dataEncrypted = await encriptarDatos(publicKey, body);
    return instance.post(`/api/remove-group-customers`, {
      data: [dataEncrypted],
    });
  };
  const deleteUserCustomer = async (publicKey, id: number) => {
    const data = await encriptarDatos(publicKey, `id=${id}`);
    return instance.delete(`/api/group-customers?data=${data}`);
  };

  return {
    login,
    logOut,
    refreshToken,
    getLines,
    getClientsByCompanyAndUser,
    getUserProviders,
    getSucursalByClient,
    getProductsByLine,
    getOrderStatus,
    getHistoricOrders,
    getDetailHistoricOrder,
    getCurrentOrder,
    addToCart,
    removeFromCart,
    cleanCart,
    sendCart,
    searchProducts,
    getDownloads,
    getDownloadsAdmin,
    getDownloadsStatics,
    getHistoricCtaCorriente,
    getPendingCtaCorriente,
    getPendingCtaCorrienteSeller,
    getConcepts,
    getSellerConcepts,
    getClientsFiles,
    getFileTypes,
    deleteFileTypes,
    getFileTypesById,
    updateFileTypes,
    createFileTypes,
    getStatistics,
    download,
    getSaleDetailsByPeriods,
    getSaleDetailsByPeriodsDetail,
    getSalesalesByClient,
    getSalesalesByClientDetail,
    healtCheck,
    getMenu,
    getPopUps,
    getGroups,
    createPopUp,
    updatePopUp,
    deletePopUp,
    disablePopUp,
    getPopUp,
    getPopUpEnabled,
    getSettings,
    updateSettings,
    getMaintenance,
    getDownloadById,
    deletePorFile,
    getUser,
    getUsers,
    changePassword,
    createUser,
    clientsByUser,
    addClient,
    removeClient,
    removeAllClients,
    updateUser,
    deleteUser,
    clientsOptions,
    getAllMenuOptions,
    permissionsByGroup,
    getPermissionOptions,
    addPermission,
    removePermission,
    updateGroup,
    createGroup,
    getGroupById,
    deleteGroupById,
    getUsersByGroup,
    downloadFileHistoricCtaCorriente,
    passwordRecovery,
    getZone,
    createFiles,
    uploadFiles,
    updateFiles,
    getOrders,
    getPendingDocuments,
    sendVoucherMail,
    getMailList,
    getComprobantesPagados,
    getAllGroupCustomers,
    getAllGroupCustomersByCompany,
    getFilteredData,
    createGroupCustomers,
    addGroupClient,
    getGroupsByUserId,
    getUsersByUsersCustomers,
    getAllGroupCustomersByUser,
    removeGroupClient,
    deleteUserCustomer,
  };
};
export default EcommerceServices;

type popUp = {
  dateFrom: Date;
  dateTo: Date;
  name: string;
  description: string;
  enabled: Number;
  groups: Number[];
};
type updatePopUp = popUp & { id: number };
type userUpdate = {
  id: Number;
  user: String;
  name: String;
  familyName: String;
  email: String;
  docket: String;
  active: 1 | 0 | null;
  userLDAP: number;
  password: String;
  providerCode: String | null;
  groups: Groups[];
  companies: Groups[];
};
type Groups = {
  id: number;
  check: Boolean;
};
